import React from 'react';
import { Users, TrendingUp, Shield } from 'lucide-react';
export function About() {
  const benefits = [{
    icon: <Users className="text-red-600" size={24} data-id="element-16" />,
    title: 'Exclusive Networking',
    description: 'Connect with fellow CFOs from top companies in an intimate setting.'
  }, {
    icon: <TrendingUp className="text-red-600" size={24} data-id="element-17" />,
    title: 'Strategic Insights',
    description: 'Gain forward-looking perspectives on financial leadership, AI integration, and 2026 planning.'
  }, {
    icon: <Shield className="text-red-600" size={24} data-id="element-18" />,
    title: 'Unique Experience',
    description: 'Combine professional development with the thrill of racing Porsches at a world-class facility.'
  }];
  return <section id="about" className="py-20 bg-gray-50" data-id="element-19">
      <div className="container mx-auto px-4 md:px-6" data-id="element-20">
        <div className="text-center mb-16" data-id="element-21">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900" data-id="element-22">
            About The Roundtable
          </h2>
          <div className="mt-4 w-24 h-1 bg-red-600 mx-auto" data-id="element-23"></div>
        </div>
        <div className="max-w-3xl mx-auto text-center mb-16" data-id="element-24">
          <p className="text-lg text-gray-700 leading-relaxed" data-id="element-25">
            The Commerce CFO Roundtable brings together forward-thinking
            financial leaders including brand CFOs and fractional CFOs for a day
            of strategic discussions, networking, and exclusive experiences.
            Hosted at the prestigious Porsche Experience Center in Los Angeles,
            this invitation-only event combines valuable insights with the
            exhilaration of performance driving.
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-26">
          {benefits.map((benefit, index) => <div key={index} className="bg-white p-8 rounded-lg shadow-md hover:shadow-lg transition-shadow" data-id="element-27">
              <div className="mb-4" data-id="element-28">{benefit.icon}</div>
              <h3 className="text-xl font-semibold mb-3" data-id="element-29">{benefit.title}</h3>
              <p className="text-gray-600" data-id="element-30">{benefit.description}</p>
            </div>)}
        </div>
      </div>
    </section>;
}